import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { giraffeState, rpc } from '@gi-nx/iframe-sdk';
import { store } from './ui/store';
import { isDemo, startDemo } from './ui/demo';
import { isPopupWindow } from './giraffe/linkPopup';
import { LinkPopupPage } from './ui/LinkPopupPage';
import './styles.css';

// The link service window (see giraffe/linkController.ts) is this same app,
// opened at `?popup=link` — a real top-level browsing context, not the
// cross-origin iframe Giraffe embeds everything else in. Rendered standalone,
// before any of the iframe-sdk/demo bootstrapping below runs.
if (isPopupWindow()) {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <LinkPopupPage />
    </StrictMode>
  );
} else {
  bootstrapApp();
}

function bootstrapApp(): void {
  if (isDemo()) startDemo();

  // The store on `window` in dev only: it is how a headless browser drives the
  // real code path without synthesising a hundred keystrokes.
  if (import.meta.env.DEV) {
    // `giraffeState` comes too: the bridge is trivially fakeable — `listen()`
    // accepts any postMessage from localhost shaped `{ type: '<key>', '<key>': v }`
    // — so a headless browser can drive the real read path with a real rotated
    // camera, rather than the map code going untested until it is in Giraffe.
    (window as unknown as { gt: unknown }).gt = { store, giraffeState, rpc };
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
